import {
  Card,
  CardTitle,
  CardBody,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import Config from "config";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import InputMask from "react-input-mask";
import { toast } from "react-toastify";

const ExploitantCard = ({ title, details, ids }) => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const [modal2, setModal2] = useState(false);
  const toggleModal1 = () => setModal2(!modal2);
  const [contactDetails, setContactDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("auth_token_" + api);
  const [editedDetails1, setEditedDetails1] = useState({});
  const [editMode1, setEditMode1] = useState(false);
  const toggleEditMode = () => setEditMode1(!editMode1);
  const styles = {
    menu: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
    }),
  };
  const handleInputChange = (key, value) => {
    setEditedDetails1((prevDetails) => ({
      ...prevDetails,
      [key]: value,
    }));
    // console.log(editedDetails1);
  };
  useEffect(() => {
    if (contactDetails) {
      setEditedDetails1(contactDetails.detail);
    }
  }, [contactDetails]);
  const sendPostRequestContact = async (requestBody) => {
    try {
      const token = localStorage.getItem("auth_token_" + api);

      if (!token) {
        throw new Error("Le jeton d'authentification est manquant");
      }

      const response = await fetch(
        `https://www.fluxod.com/${api}/partenaires/update_contact`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(requestBody),
        }
      );

      // Vérifier la réponse
      if (!response.ok) {
        const errorText = await response.text(); // Lire le texte de l'erreur
        toast.error("Mis à jour échouée");
        throw new Error(`La requête a échoué : ${errorText}`);
      }
      toast.success("Mis à jour réussie");
      // Traitement de la réponse
      const data = await response.json();
      return data; // Retourner les données si nécessaire
    } catch (error) {
      console.error("Erreur lors de l'envoi de la requête POST:", error);
      throw new Error(error.message); // Lancer une erreur avec le message original
    }
  };
  const sendPostRequestSociete = async (requestBody) => {
    try {
      const token = localStorage.getItem("auth_token_" + api);

      if (!token) {
        throw new Error("Le jeton d'authentification est manquant");
      }

      const response = await fetch(
        `https://www.fluxod.com/${api}/partenaires/update_societe`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(requestBody),
        }
      );

      // Vérifier la réponse
      if (!response.ok) {
        const errorText = await response.text(); // Lire le texte de l'erreur
        toast.success("Mis à jour échouée");
        throw new Error(`La requête a échoué : ${errorText}`);
      }
      toast.success("Mis à jour réussie");
      // Traitement de la réponse
      const data = await response.json();
      return data; // Retourner les données si nécessaire
    } catch (error) {
      console.error("Erreur lors de l'envoi de la requête POST:", error);
      throw new Error(error.message); // Lancer une erreur avec le message original
    }
  };

  const handleSaveChanges = async () => {
    try {
      if (ids.contact2_id) {
        const requestBody = {
          id: ids.contact2_id,
          titre_id: editedDetails1.Titre?.value,
          nom: editedDetails1.Nom,
          prenom: editedDetails1.Prénom,
          societe_id: editedDetails1.Société?.value,
          date_de_naissance: editedDetails1["Date de naissance"],
          ville_de_naissance: editedDetails1["Ville de naissance"],
          departement_ou_pays: editedDetails1["Code département de naissance"],
          situation_matrimoniale_id:
            editedDetails1["Situation matrimoniale"]?.value,
          profession: editedDetails1.Profession,
          adresse: editedDetails1.Adresse,
          complement: editedDetails1.Complément,
          code_postal: editedDetails1["Code postal"],
          ville: editedDetails1.Ville,
          pay_id: editedDetails1.Pays ? editedDetails1.Pays?.value : null,
          tel_fix: editedDetails1["Téléphone fixe"],
          tel_mobil: editedDetails1["Téléphone mobile"],
          email_pro: editedDetails1["Email pro."],
          email_perso: editedDetails1["Email perso."],
        };

        // Envoyer la requête POST pour contact
        await sendPostRequestContact(requestBody);
      }

      setEditMode1(false);

      toggleModal1();
    } catch (error) {
      console.error(
        "Erreur lors de l'enregistrement des modifications:",
        error
      );
    }
  };

  const renderField = (key, value) => {
    return editMode1 ? (
      key == "Titre" ? (
        <Select
          defaultValue={{ label: value.label, value: value.value }}
          options={renderTitreOptions()}
          onChange={(selectedOption) => handleInputChange(key, selectedOption)}
          styles={styles}
        />
      ) : key == "Société" ? (
        <Select
          defaultValue={{ label: value?.label, value: value?.value }}
          options={renderSocieteOptions()}
          onChange={(selectedOption) => handleInputChange(key, selectedOption)}
          styles={styles}
        />
      ) : key == "Situation matrimoniale" ? (
        <Select
          defaultValue={{ label: value?.label, value: value?.value }}
          options={renderSituationMatrimonialeOptions()}
          onChange={(selectedOption) => handleInputChange(key, selectedOption)}
          styles={styles}
        />
      ) : key == "Pays" ? (
        <Select
          defaultValue={{ label: value?.label, value: value?.value }}
          options={renderPaysOptions()}
          onChange={(selectedOption) => handleInputChange(key, selectedOption)}
          styles={styles}
        />
      ) : key == "Forme juridique" ? (
        <Select
          defaultValue={{ label: value?.label, value: value?.value }}
          options={renderFormeOptions()}
          onChange={(selectedOption) => handleInputChange(key, selectedOption)}
          styles={styles}
        />
      ) : key == "Président (PP)" ? (
        <Select
          defaultValue={{ label: value?.label, value: value?.value }}
          options={renderDirecteurOptions()}
          onChange={(selectedOption) => handleInputChange(key, selectedOption)}
          styles={styles}
        />
      ) : key == "Directeur Général" ? (
        <Select
          defaultValue={{ label: value?.label, value: value?.value }}
          options={renderDirecteurOptions()}
          onChange={(selectedOption) => handleInputChange(key, selectedOption)}
          styles={styles}
        />
      ) : key == "Président (PM)" ? (
        <Select
          defaultValue={{ label: value?.label, value: value?.value }}
          options={renderPresidentOptions()}
          onChange={(selectedOption) => handleInputChange(key, selectedOption)}
          styles={styles}
        />
      ) : key == "Date de naissance" ? (
        <InputMask
          mask="99/99/9999"
          value={editedDetails1[key]}
          className="form-control input-color"
          onChange={(e) => handleInputChange(key, e.target.value)}
        />
      ) : (
        <Input
          type="text"
          defaultValue={editedDetails1[key]}
          onChange={(e) => handleInputChange(key, e.target.value)}
        />
      )
    ) : (
      <span>
        {typeof value === "object" && value !== null ? value.label : value}
      </span>
    );
  };
  // Select Options
  /*************************   SituationMatrimoniale  *******************************/
  const [situationMatrimonialeData, setSituationMatrimonialeData] = useState({
    data: [],
  });

  const [selectedSituationMatrimoniale, setSelectedSituationMatrimoniale] =
    useState("");

  const renderSituationMatrimonialeOptions = () => {
    return [
      {
        options: situationMatrimonialeData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handleSituationMatrimonialeChange = (e) => {
    setSelectedSituationMatrimoniale(e);
  };
  const getSituationMatrimoniale = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investisseurs/situation_matrimoniales`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((situationMatrimoniale) => {
          setSituationMatrimonialeData(situationMatrimoniale);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END SituationMatrimoniale *******************************/
  /*************************   Pays  *******************************/
  const [payData, setPayData] = useState({ data: [] });
  const renderPaysOptions = () => {
    return [
      {
        options: payData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const getPay = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/pays`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pay) => {
          setPayData(pay);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Pays *******************************/
  /*************************   Titre  *******************************/
  const [titreData, setTitreData] = useState({ data: [] });
  const renderTitreOptions = () => {
    return [
      {
        options: titreData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  const getTitre = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/titres`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((titre) => {
          setTitreData(titre);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Titre *******************************/
  /*************************   Societe  *******************************/
  const [societeData, setSocieteData] = useState({ data: [] });
  const renderSocieteOptions = () => {
    return [
      {
        options: societeData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const getSociete = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/societes`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((societe) => {
          setSocieteData(societe);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Societe *******************************/
  /*************************   Formes juridiques         *******************************/
  const [formeJuridique, setFormeJuridique] = useState({ data: [] });
  const renderFormeOptions = () => {
    return [
      {
        options: formeJuridique.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const getFormeJuri = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/formes_juridiques`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((formeJuridique) => {
          setFormeJuridique(formeJuridique);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Formes juridiques         *******************************/

  /*************************   Président PM          *******************************/
  const [presidentData, setPresidentData] = useState({ data: [] });
  const renderPresidentOptions = () => {
    return [
      {
        options: presidentData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  const getPresident = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/societes2`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((president) => {
          setPresidentData(president);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END President         *******************************/

  /*************************   Directeur          *******************************/
  const [directeurData, setDirecteurData] = useState({ data: [] });
  const renderDirecteurOptions = () => {
    return [
      {
        options: directeurData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  const getDirecteur = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/contacts`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((directeur) => {
          setDirecteurData(directeur);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Directeur         *******************************/
  useEffect(() => {
    const fetchData = async () => {
      if (modal2 && ids?.contact2_id) {
        setLoading(true);
        try {
          const response = await fetch(
            `https://www.fluxod.com/${api}/partenaires/show_contact?contact_id=${ids.contact2_id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (!response.ok) {
            throw new Error(
              "Erreur lors de la récupération des détails de contact"
            );
          }
          const data = await response.json();
          setContactDetails(data);
          setLoading(false);
        } catch (error) {
          setError(error);
          setLoading(false);
        }
        getPay();
        getSociete();
        getSituationMatrimoniale();
        getTitre();
      }
    };

    fetchData();
  }, [modal2]);
  // useEffect(() => {

  // }, []);
  return (
    <Card className="mb-4">
      <CardTitle tag="h5" style={{ paddingLeft: 10 }}>
        {title}
      </CardTitle>
      <CardBody>
        {details ? (
          Object.entries(details).map(([key, value], index) => (
            <Row key={index} className="mb-3">
              <Col className="col-4" style={{ whiteSpace: "nowrap" }}>
                <i style={{ color: "#9d9c9c" }}>
                  <span
                    style={{
                      display: "inline-block",
                      width: "8em",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {key} :
                  </span>
                </i>
              </Col>
              <Col className="col-8" style={{ textAlign: "right" }}>
                <span
                  style={{
                    paddingInlineStart: "8em",
                    whiteSpace: "pretty",
                    fontFamily: "sans-serif",
                  }}
                >
                  {key.includes("€") ? (
                    renderValue(value).toLocaleString("fr-FR", {
                      style: "currency",
                      currency: "EUR",
                    })
                  ) : key.includes("%") ? (
                    renderValue(value).toLocaleString("fr-FR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) + " %"
                  ) : key == "Fichier" && value != null ? (
                    <a href={value} download>
                      <i
                        style={{
                          fontSize: "25px",
                          paddingLeft: "8px",
                          textalign: "center",
                          verticalalign: "middle",
                        }}
                        className="bx bx-download"
                      ></i>
                    </a>
                  ) : key == "Réservation" && ids?.reservation_id != null ? (
                    <Link
                      to={`${backUrl}/reservations/${ids.reservation_id}`}
                      className="text-decoration-underline"
                      style={{
                        color: "#555B21",
                      }}
                    >
                      {value}
                    </Link>
                  ) : key == "PME" && ids?.pme_id != null ? (
                    <Link
                      to={`${backUrl}/pmes/${ids.pme_id}`}
                      className="text-decoration-underline"
                      style={{
                        color: "#555B21",
                      }}
                    >
                      {value}
                    </Link>
                  ) : key == "Investissement" &&
                    ids?.investissement_id != null ? (
                    <Link
                      to={`${backUrl}/investissements/${ids.investissement_id}`}
                      className="text-decoration-underline"
                      style={{
                        color: "#555B21",
                      }}
                    >
                      {value}
                    </Link>
                  ) : key == "Exploitant" && ids?.partenaire2_id != null ? (
                    <Link
                      to={`${backUrl}/partenaires_exploitants/${ids.partenaire2_id}`}
                      className="text-decoration-underline"
                      style={{
                        color: "#555B21",
                      }}
                    >
                      {value}
                    </Link>
                  ) : key == "Comptable" && ids?.contact2_id != null ? (
                    <span
                      onClick={toggleModal1}
                      className="text-decoration-underline"
                      style={{ color: "#555B21", cursor: "pointer" }}
                    >
                      {value}
                    </span>
                  ) : (
                    renderValue(value)
                  )}
                  {}
                </span>
              </Col>
            </Row>
          ))
        ) : (
          <></>
        )}
      </CardBody>
      <Modal isOpen={modal2} toggle={toggleModal1}>
        <ModalHeader toggle={toggleModal1}>Détails</ModalHeader>
        <ModalBody>
          {" "}
          <Row className="mb-3">
            {contactDetails &&
              Object.entries(contactDetails.detail).map(
                ([key, value], index) => (
                  <>
                    <Col xs={12} md={6} className="mb-2">
                      <Label
                        className="font-weight-bold"
                        style={{ paddingTop: editMode1 ? 10 : 0 }}
                      >
                        {key} :
                      </Label>{" "}
                      {renderField(key, value)}
                    </Col>
                  </>
                )
              )}
          </Row>
        </ModalBody>
        <ModalFooter>
          {editMode1 ? (
            <>
              <Button color="success" onClick={handleSaveChanges}>
                Sauvegarder
              </Button>
              <Button color="secondary" onClick={toggleEditMode}>
                Annuler
              </Button>
            </>
          ) : (
            <Button color="secondary" onClick={toggleEditMode}>
              Modifier
            </Button>
          )}
          <Button color="secondary" onClick={toggleModal1}>
            Fermer
          </Button>
        </ModalFooter>
      </Modal>
    </Card>
  );
};

const renderValue = (value) => {
  if (value == null) {
    return "";
  } else if (typeof value === "string" && value.trim() === "") {
    return "";
  } else if (value === "Validé" || value === "Oui") {
    return <span className="bg-success badge bg-secondary">{value}</span>;
  } else if (value === "En attente") {
    return <span className="bg-info badge bg-secondary">{value}</span>;
  } else if (value === "Non") {
    return (
      <span
        className="badge-soft-danger badge bg-secondary"
        style={{ fontSize: "100%" }}
      >
        {value}
      </span>
    );
  } else {
    return value;
  }
};
export default ExploitantCard;
